import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

const PROJECTS = [
  {
    to: "/perform-fitness",
    ns: "performFitness",
    tags: ["React Native", "iOS", "SQLite"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="8" width="3" height="8" rx="1"/>
        <rect x="4" y="10" width="2" height="4" rx="0.5"/>
        <line x1="6" y1="12" x2="18" y2="12"/>
        <rect x="18" y="10" width="2" height="4" rx="0.5"/>
        <rect x="20" y="8" width="3" height="8" rx="1"/>
      </svg>
    ),
  },
  {
    to: "/camper-monitor",
    ns: "camperMonitor",
    tags: ["Node.js", "React", "BLE", "Raspberry Pi"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="12" rx="1.5"/>
        <line x1="2" y1="11" x2="22" y2="11"/>
        <rect x="4" y="7" width="5" height="4" rx="0.5"/>
        <rect x="11" y="7" width="4" height="4" rx="0.5"/>
        <circle cx="7" cy="19" r="2"/>
        <circle cx="17" cy="19" r="2"/>
      </svg>
    ),
  },
  {
    to: "/camper-solar-monitor-app",
    ns: "camperSolarMonitorApp",
    tags: ["iOS", "Swift", "BLE"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="4"/>
        <line x1="12" y1="2" x2="12" y2="4"/>
        <line x1="12" y1="20" x2="12" y2="22"/>
        <line x1="4.93" y1="4.93" x2="6.34" y2="6.34"/>
        <line x1="17.66" y1="17.66" x2="19.07" y2="19.07"/>
        <line x1="2" y1="12" x2="4" y2="12"/>
        <line x1="20" y1="12" x2="22" y2="12"/>
        <line x1="4.93" y1="19.07" x2="6.34" y2="17.66"/>
        <line x1="17.66" y1="6.34" x2="19.07" y2="4.93"/>
      </svg>
    ),
  },
  {
    to: "/btble-scanner",
    ns: "btScanner",
    tags: ["React Native", "iOS", "BLE"],
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"/>
      </svg>
    ),
  },
];

function Development() {
  const { t } = useLang();

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">{t("development.label")}</span>
        <div className="subhead">{t("development.title")}</div>
        {t("development.intro").map((p, i) => (
          <p key={i} className="section-intro-inner">{p}</p>
        ))}
      </div>

      <div className="project-cards">
        {PROJECTS.map(({ to, ns, tags, icon }) => (
          <Link key={to} to={to} className="project-card-link">
            <div className="project-card">
              <div className="project-card-icon">{icon}</div>
              <div className="project-card-body">
                <h3>{t(`${ns}.title`)}</h3>
                <p>{t(`${ns}.intro`)}</p>
                <div className="project-tags">
                  {tags.map(tag => <span key={tag} className="tool-tag">{tag}</span>)}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Development;
